import axios from 'axios';

export async function optimalBlueProductSearch(input) {
  try {
    return await axios.post(`${process.env.REACT_APP_MCCC_API_URL}/refi/optimal-blue/product/search`, input);
  } catch (error) {
    console.error(error);
    return error;
  }
}
